
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "family-component",
components: {
Group,
XInput,
Selector,
},
props:{
fname:String,
frelate:String,
fphone:String,
fidcard:String,
fjok:String,
fwork:String,
},
data() {
return{
relations: [{key: '1', value: '父亲'}, {key: '2', value: '母亲'}, {key: '3',value:'其他'}]
}
},
computed: {

},
methods: {
showVal(val){
var param = {
"guardian":this.fname,
"relation":this.frelate,
"phone":this.fphone,
"guardianidentifyId":this.fidcard,
"job":this.fjok,
"workplace":this.fwork
};
this.$emit("changeVal",param)
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/family-component.vue